// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"6b50d91c","350":"31f114d0","441":"1b7518b7","453":"6f0b027e","538":"23c576f4","884":"cca379d3","916":"038dd388","985":"b1cc5791"}[chunkId] + ".chunk.js";
};